module.exports = __webpack_public_path__ + "img/ico-pressure-edit-p.e8b0924a.png";